import React from "react";

const AlertPopup = ({
  open,
  onClose,
  title = "Alert!",
  message = "Quiz attempts limit reached.",
  actionLabel = "Buy Re-attempts Addons",
  hideAction = false,
}) => {
  if (!open) {
    return null;
  }

  return (
    <div className="modal-overlay resetModal unlockModal delModal" onClick={onClose}>
      <div className="modal-container text-center rounded-4" onClick={(event) => event.stopPropagation()}>
        <div className="close-btn2 text-end unlock-close-btn">
          <button type="button" className="btn-close" onClick={onClose} aria-label="Close" />
        </div>

        <div className="premium-icon alertpopup-icon">
          <i className="bi bi-info-circle" />
        </div>

        <h5 className="fw-bold blackText mb-2 alert-title">{title}</h5>
        <p className="fw-medium alertpopup-text">{message}</p>

        {!hideAction ? (
          <div>
            <button type="button" className="start-quiz-btn w-100">
              <span>{actionLabel}</span>
            </button>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default AlertPopup;
